import React, { useState, useEffect } from "react";
import "swiper/css";
import { useTranslation } from "react-i18next";
import Slider from "../../Slider/Slider";

const SeatsAvailableOpenTable = ({
  intervals,
  onSeatChange,
  selectedSeatType,
}) => {
  const { t } = useTranslation();
  const [seatOptions, setSeatOptions] = useState([]);
  const [selectedSeatOption, setSelectedSeatOption] = useState(
    selectedSeatType || ""
  );

  const translateAttribute = (attr) => {
    switch (attr) {
      case "default":
        return t("translateAttribute.default");
      case "counter":
        return t("translateAttribute.counter");
      case "highTop":
        return t("translateAttribute.highTop");
      case "outdoor":
        return t("translateAttribute.outdoor");
      case "bar":
        return t("translateAttribute.bar");
      default:
        return attr;
    }
  };

  useEffect(() => {
    if (!intervals || intervals.length === 0) {
      setSeatOptions([]);
      setSelectedSeatOption("");
      if (onSeatChange && selectedSeatOption !== "") {
        onSeatChange("");
      }
      return;
    }

    const allAttributes = intervals.flatMap(
      (interval) => interval.attributes || []
    );
    const uniqueAttributes = Array.from(new Set(allAttributes));
    const options = uniqueAttributes.map((attr, index) => ({
      id: index + 1,
      label: translateAttribute(attr),
      value: attr,
    }));

    setSeatOptions(options);

    const defaultOption =
      options.find((option) => option.value === "default") || options[0];
    if (
      !selectedSeatType ||
      !options.some((option) => option.value === selectedSeatType)
    ) {
      const newSeat = defaultOption ? defaultOption.value : "";
      setSelectedSeatOption(newSeat);
      if (onSeatChange && newSeat !== selectedSeatType) {
        onSeatChange(newSeat);
      }
    } else if (selectedSeatType !== selectedSeatOption) {
      setSelectedSeatOption(selectedSeatType);
    }
  }, [intervals, selectedSeatType]);

  const handleSeatSelection = (seatValue) => {
    if (seatValue !== selectedSeatOption) {
      setSelectedSeatOption(seatValue);
      if (onSeatChange) {
        onSeatChange(seatValue);
      }
    }
  };

  return (
    <>
      <div className="mt-3 mb-2 mb-1 text-secondary fw-bold">
        {t("seatingOptionsAvailable")}
      </div>
      <div className="mb-4">
        <Slider
          slideSpacing={10}
          initialSlide={0}
          touchScroll={true}
          showBtns={false}
          visibleSlides={"all"}
        >
          {seatOptions.map((option) => (
            <div key={option.id}>
              <button
                className={`btn btn-primary selector text-left font-tiny btn-square ${
                  selectedSeatOption === option.value
                    ? "selected-seat"
                    : "btn-outline"
                }`}
                onClick={() => handleSeatSelection(option.value)}
              >
                {option.label}
              </button>
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
};

export default SeatsAvailableOpenTable;
